export default "__VITE_ASSET__CZ72pJ0u__"